import { Table } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

const getIcon = (value, suffix = true) => {
  return value === "Yes" || value === true ? (
    <>
      <CheckOutlined style={{ color: "green" }} />
      {suffix && " Yes"}
    </>
  ) : (
    <>
      <CloseOutlined style={{ color: "red" }} />
      {suffix && " No"}
    </>
  );
};

const supportedDocumentTypes = [
  {
    type: "PDFs",
    nativeText: true,
    lowCost: true,
    highQuality: true,
    highQualityFormElements: true,
  },
  {
    type: "PDF forms",
    nativeText: false,
    lowCost: false,
    highQuality: false,
    highQualityFormElements: true,
  },
  {
    type: "Images (JPEG, PNG, TIFF)",
    nativeText: false,
    lowCost: true,
    highQuality: true,
    highQualityFormElements: true,
  },
  {
    type: "MS Office Document",
    nativeText: true,
    lowCost: true,
    highQuality: true,
    highQualityFormElements: true,
  },
  {
    type: "MS Office Excel",
    nativeText: true,
    lowCost: true,
    highQuality: true,
    highQualityFormElements: true,
  },
  {
    type: "MS Office Powerpoint",
    nativeText: true,
    lowCost: true,
    highQuality: true,
    highQualityFormElements: true,
  },
  {
    type: "LibreOffice Writer",
    nativeText: true,
    lowCost: true,
    highQuality: true,
    highQualityFormElements: true,
  },
  {
    type: "LibreOffice Calc",
    nativeText: true,
    lowCost: true,
    highQuality: true,
    highQualityFormElements: true,
  },
  {
    type: "LibreOffice Impress",
    nativeText: true,
    lowCost: true,
    highQuality: true,
    highQualityFormElements: true,
  },
];

const dataSource = [
  {
    key: "1",
    feature: "Cost",
    nativeText: "$1/1,000 pages",
    lowCost: "$5/1,000 pages",
    highQuality: "$10/1,000 pages",
    highQualityFormElements: "$15/1,000 pages",
  },
  {
    key: "2",
    feature: "Supported document types",
    nativeText: supportedDocumentTypes.map((doc) => (
      <div key={doc.type}>
        {getIcon(doc.nativeText, false)} {doc.type}
      </div>
    )),
    lowCost: supportedDocumentTypes.map((doc) => (
      <div key={doc.type}>
        {getIcon(doc.lowCost, false)} {doc.type}
      </div>
    )),
    highQuality: supportedDocumentTypes.map((doc) => (
      <div key={doc.type}>
        {getIcon(doc.highQuality, false)} {doc.type}
      </div>
    )),
    highQualityFormElements: supportedDocumentTypes.map((doc) => (
      <div key={doc.type}>
        {getIcon(doc.highQualityFormElements, false)} {doc.type}
      </div>
    )),
  },
  {
    key: "3",
    feature: "Checkbox and Radio button detection",
    nativeText: getIcon("No"),
    lowCost: getIcon("No"),
    highQuality: getIcon("No"),
    highQualityFormElements: getIcon("Yes"),
  },
  {
    key: "4",
    feature: "Lines reproduction in output",
    nativeText: getIcon("No"),
    lowCost: getIcon("Yes"),
    highQuality: getIcon("Yes"),
    highQualityFormElements: getIcon("Yes"),
  },
  {
    key: "5",
    feature: "Extraction performance",
    nativeText: "Very fast",
    lowCost: "Fast",
    highQuality: "Medium",
    highQualityFormElements: "Medium",
  },
  {
    key: "6",
    feature: "Image preprocessing (median filter and gaussian blur)",
    nativeText: getIcon("No"),
    lowCost: getIcon("Yes"),
    highQuality: getIcon("No"),
    highQualityFormElements: getIcon("No"),
  },
  {
    key: "7",
    feature: "Line splitting strategy choice",
    nativeText: getIcon("Yes"),
    lowCost: getIcon("Yes"),
    highQuality: getIcon("Yes"),
    highQualityFormElements: getIcon("Yes"),
  },
  {
    key: "8",
    feature: "Supported languages",
    nativeText: "All (unicode)",
    lowCost: "120+ (default is English)",
    highQuality: "300+",
    highQualityFormElements: "300+",
  },
  {
    key: "9",
    feature: "Handwriting recognition",
    nativeText: getIcon("No"),
    lowCost: "Basic Support",
    highQuality: getIcon("Yes"),
    highQualityFormElements: getIcon("Yes"),
  },
  {
    key: "10",
    feature: "Layout preserving output",
    nativeText: getIcon("Yes"),
    lowCost: getIcon("Yes"),
    highQuality: getIcon("Yes"),
    highQualityFormElements: getIcon("Yes"),
  },
  {
    key: "11",
    feature: "AI/ML based enhancement",
    nativeText: getIcon("No"),
    lowCost: getIcon("No"),
    highQuality: getIcon("Yes"),
    highQualityFormElements: getIcon("Yes"),
  },
  {
    key: "12",
    feature: "Rotation and skew compensation",
    nativeText: "N/A",
    lowCost: getIcon("No"),
    highQuality: getIcon("Yes"),
    highQualityFormElements: getIcon("Yes"),
  },
  {
    key: "13",
    feature: "Auto repair PDFs",
    nativeText: getIcon("No"),
    lowCost: getIcon("Yes"),
    highQuality: getIcon("Yes"),
    highQualityFormElements: getIcon("Yes"),
  },
  {
    key: "14",
    feature: "Dense text content",
    nativeText: "Best performance",
    lowCost: "Very good",
    highQuality: "Very good",
    highQualityFormElements: "Very good",
  },
  {
    key: "15",
    feature:
      "High entropy content (each page contains large variety of text sizes)",
    nativeText: "Best performance",
    lowCost: "Very good",
    highQuality: "Very good",
    highQualityFormElements: "Very good",
  },
  {
    key: "16",
    feature: "Recommended use cases",
    nativeText: (
      <div>
        * Low latency requirement <br />
        * All documents are PDFs <br />
        * PDFs are native text PDFs <br />* Cost sensitive application
      </div>
    ),
    lowCost: (
      <div>
        * High quality scanned PDFs <br />
        * High quality scanned images <br />* No handwritten documents
      </div>
    ),
    highQuality: (
      <div>
        * Medium/low quality scanned PDFs <br />
        * Medium/low quality scanned images <br />* Handwritten documents
      </div>
    ),
    highQualityFormElements: (
      <div>
        * Checkbox and radio button detection <br />
        * Medium/low quality scanned PDFs <br />* Medium/low quality scanned
        images <br />* Handwritten documents
      </div>
    ),
  },
];

const columns = [
  {
    title: "LLMWhisperer Processing Modes",
    children: [
      {
        title: "Name",
        dataIndex: "feature",
        key: "feature",
      },
      {
        title: "Native Text",
        dataIndex: "nativeText",
        key: "nativeText",
      },
      {
        title: "Low Cost",
        dataIndex: "lowCost",
        key: "lowCost",
      },
      {
        title: "High Quality",
        dataIndex: "highQuality",
        key: "highQuality",
      },
      {
        title: "High Quality with Form Elements",
        dataIndex: "highQualityFormElements",
        key: "highQualityFormElements",
      },
    ],
  },
];

const ServiceLevelsTable = () => {
  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      scroll={{ y: 500 }}
      className="service-level-table"
    />
  );
};

export default ServiceLevelsTable;
